import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { ItemDto } from "src/dtos/item/itemDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { MST1011_R01Dto } from "./Dto_MST1011_R01";
import { MST1011_R01Filter } from "./Store_MST1011_R01";

const itemUrl = `${config.apiUrl}/MST1011_R01`;


export const getMST1011_R01List = async ( option: string, params: Partial<MST1011_R01Filter>, listLength: number = 0) => {
	const url = `${itemUrl}/${option}`;

	return await getData<ResponseDto<ItemDto[]>>(url, { params: {
		...params,
		listLength
	} })
}

export const getMST1011_R01AllCount = async (params: Partial<MST1011_R01Filter>) => {
    const url = `${itemUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            ...params
        }
    });
}	

export const getMST1011_R01One = async (itemCd: string) => {
	const url = `${itemUrl}/one/${itemCd}`;

	return await getData<ResponseDto<ItemDto>>(url);
}

export const getMST1011_R01Image = async (itemCd: string) => {
	const url = `${itemUrl}/image/${itemCd}`;

	return await getData<ResponseDto<ItemDto>>(url);
}	


export const createMST1011_R01 = async (data: ItemDto) => {

	return await postData<ItemDto, ResponseDto<ItemDto>>(itemUrl, data);
}

export const patchMST1011_R01 = async (data: ItemDto) => {

	return await patchData<ItemDto, ResponseDto<ItemDto>>(itemUrl, data);
}

export const deleteMST1011_R01 = async (itemCd: string) => {
	const url = `${itemUrl}/${itemCd}`;

	return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_MST1011_R01 = async ( option: string, params: Partial<MST1011_R01Filter>, listLength: number = 0) => {

	const url = `${itemUrl}/excel/${option}`;

	return await getData<ResponseDto<string>>(url, { params: {
		...params,
		listLength
	} })
}

export const postMST1011_R01ItemGroupAccount = async (editData: MST1011_R01Dto) => {
	const url = `${itemUrl}/generateItemCd/${editData.customCd}/${editData.itemGroup}`;

	return await getData<ResponseDto<string>>(url);
}